// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* ========== 原有样式 ========== */

.monaco-editor_container_MRSSZ {
  position: relative;
  height: 100%;
  width: 100%;
}

.monaco-editor_toolbar_wEfZ2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  background: var(--ui-secondary);
  border-bottom: 1px solid var(--ui-tertiary);
  min-height: 40px;
  height: 40px;
  box-sizing: border-box;
}

.monaco-editor_languageSelector_qodI4 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.monaco-editor_toolbarLabel_ZmYqI {
  font-size: 0.875rem;
  color: var(--ui-modal-foreground);
  font-weight: 500;
}

.monaco-editor_languageButton_a_eiu {
  font-family: inherit;
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
  margin: 0;
  border: 1px solid var(--ui-tertiary);
  border-radius: 4px;
  cursor: pointer;
  background: var(--ui-tertiary);
  color: var(--ui-modal-foreground);
  transition: all 0.2s ease;
}

.monaco-editor_languageButton_a_eiu:hover {
  background: var(--badge-border);
  border-color: var(--looks-secondary);
}

.monaco-editor_activeLanguage_ABYw_ {
  background: var(--looks-secondary);
  color: white;
  border-color: var(--looks-secondary);
}

.monaco-editor_activeLanguage_ABYw_:hover {
  background: var(--looks-secondary);
  filter: brightness(1.1);
}

.monaco-editor_toolbarActions_OchyJ {
  display: flex;
  gap: 0.5rem;
}

.monaco-editor_toolbarButton_LCd1A {
  font-family: inherit;
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
  margin: 0;
  border: 1px solid var(--ui-tertiary);
  border-radius: 4px;
  cursor: pointer;
  background: var(--ui-tertiary);
  color: var(--ui-modal-foreground);
  transition: all 0.2s ease;
}

.monaco-editor_toolbarButton_LCd1A:hover {
  background: var(--badge-border);
  border-color: var(--looks-secondary);
}

.monaco-editor_editorContainer_eeHrh {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  bottom: 0;
}

.monaco-editor_loading_lndwQ {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: var(--ui-modal-foreground);
  font-size: 1rem;
}

.monaco-editor_error_oftdq {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: var(--error-primary);
  font-size: 1rem;
  padding: 1rem;
  text-align: center;
}

.file-selection-modal {
  width: 320px !important;
  max-width: 320px !important;
}

/* ========== 编辑器主体布局样式 ========== */

.monaco-editor_editor-wrapper_VVwNC {
  display: flex;
  height: 100%;
  width: 100%;
}

/* ========== 侧边栏样式 ========== */

.monaco-editor_sidebar_ybah9 {
  width: 200px;
  background-color: var(--ui-secondary);
  border-right: 1px solid var(--ui-tertiary);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.monaco-editor_sidebar-header_sPNpp {
  padding: 12px 16px;
  border-bottom: 1px solid var(--ui-tertiary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--ui-tertiary);
}

.monaco-editor_sidebar-title_xqHHU {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: var(--text-primary);
}

.monaco-editor_file-list_VzHlx {
  flex: 1;
  overflow: auto;
  padding: 8px 0;
}

.monaco-editor_file-item_IksU6 {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  cursor: pointer;
  background-color: transparent;
  border-left: 2px solid transparent;
  transition: background-color 0.15s;
}

.monaco-editor_file-item_IksU6:hover {
  background-color: var(--badge-border);
}

.monaco-editor_file-item_IksU6.monaco-editor_active_ESw8f {
  background-color: var(--badge-border);
  border-left-color: var(--looks-secondary);
}

.monaco-editor_file-icon_s6fkY {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  color: #fff;
  flex-shrink: 0;
}

.monaco-editor_file-icon_s6fkY.monaco-editor_light-text_M3Q3m {
  color: #000;
}

.monaco-editor_file-name_q8jeY {
  flex: 1;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-primary);
}

.monaco-editor_file-actions_Qo7OT {
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.15s;
}

.monaco-editor_file-item_IksU6:hover .monaco-editor_file-actions_Qo7OT {
  opacity: 1;
}

.monaco-editor_file-action-btn_yGGsV {
  padding: 2px 4px;
  font-size: 12px;
  cursor: pointer;
  background: transparent;
  border: none;
  color: var(--ui-text-primary-transparent);
}

.monaco-editor_file-action-btn_yGGsV:hover {
  color: var(--text-primary);
}

/* ========== 新建文件区域 ========== */

.monaco-editor_new-file-section_GLm50 {
  padding: 8px 12px;
  border-top: 1px solid var(--looks-secondary);
}

.monaco-editor_new-file-input_wcSpx {
  width: 100%;
  padding: 6px 8px;
  font-size: 13px;
  border: 1px solid var(--looks-secondary);
  border-radius: 3px;
  background-color: var(--ui-primary);
  color: var(--text-primary);
  outline: none;
  font-family: inherit;
}

.monaco-editor_new-file-input_wcSpx::-ms-input-placeholder {
  color: var(--ui-text-primary-transparent);
}

.monaco-editor_new-file-input_wcSpx::placeholder {
  color: var(--ui-text-primary-transparent);
}

.monaco-editor_new-file-actions_tHDFJ {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.monaco-editor_new-file-btn-create_lybLp {
  padding: 4px 12px;
  font-size: 12px;
  background-color: var(--looks-secondary);
  color: #fff;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-family: inherit;
}

.monaco-editor_new-file-btn-create_lybLp:hover {
  filter: brightness(1.1);
}

.monaco-editor_new-file-btn-cancel_yS4Cd {
  padding: 4px 12px;
  font-size: 12px;
  background-color: transparent;
  color: var(--ui-text-primary-transparent);
  border: 1px solid var(--ui-tertiary);
  border-radius: 3px;
  cursor: pointer;
  font-family: inherit;
}

.monaco-editor_new-file-btn-cancel_yS4Cd:hover {
  border-color: var(--ui-text-primary-transparent);
}

.monaco-editor_new-file-trigger_KajD8 {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  background-color: var(--ui-secondary);
  color: var(--ui-text-primary-transparent);
  font-size: 13px;
  transition: background-color 0.15s;
  font-family: inherit;
  border: none;
  width: 100%;
  text-align: left;
}

.monaco-editor_new-file-trigger_KajD8:hover {
  background-color: var(--looks-secondary);
}

.monaco-editor_new-file-icon_qI7JL {
  font-size: 16px;
}

/* ========== 编辑器区域样式 ========== */

.monaco-editor_editor-area_AbVwU {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.monaco-editor_editor-header_nw6W8 {
  padding: 8px 16px;
  border-bottom: 1px solid var(--ui-tertiary);
  background-color: var(--ui-tertiary);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.monaco-editor_editor-header-left_vkLDc,
.monaco-editor_editor-header-right_PDzx3 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.monaco-editor_editor-filename_V6Eu5 {
  font-size: 13px;
  color: var(--text-primary);
}

/* ========== 缩放控制 ========== */

.monaco-editor_zoom-control_Np_vk {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  background-color: var(--ui-tertiary);
  border-radius: 4px;
}

.monaco-editor_zoom-btn_RLZvn {
  background: none;
  border: none;
  color: var(--text-primary);
  cursor: pointer;
  font-size: 14px;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: inherit;
}

.monaco-editor_zoom-btn_RLZvn:hover {
  background-color: var(--badge-border);
}

.monaco-editor_zoom-value_LFgyB {
  font-size: 11px;
  color: var(--ui-text-primary-transparent);
  min-width: 30px;
  text-align: center;
}

/* ========== 生成积木按钮 ========== */

.monaco-editor_generate-btn_Hxu8n {
  padding: 6px 12px;
  font-size: 12px;
  background-color: var(--looks-secondary);
  color: #fff;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: inherit;
}

.monaco-editor_generate-btn_Hxu8n:hover {
  filter: brightness(1.1);
}

/* ========== 编辑器容器 ========== */

.monaco-editor_editor-content_h9MU1 {
  flex: 1;
  overflow: hidden;
}

/* ========== 空状态 ========== */

.monaco-editor_empty-state_P8ThV {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--ui-text-primary-transparent);
  font-size: 14px;
}

.monaco-editor_empty-state-hint_fLrb9 {
  font-size: 12px;
  margin-top: 8px;
}

/* ========== 状态消息 ========== */

.monaco-editor_status-message_HTKs_ {
  padding: 8px 16px;
  font-size: 12px;
  border-bottom: 1px solid var(--ui-tertiary);
}

.monaco-editor_status-message_HTKs_.monaco-editor_success_E5Uj1 {
  background-color: rgba(76, 175, 80, 0.2);
  color: #4caf50;
}

.monaco-editor_status-message_HTKs_.monaco-editor_warning_bNkwk {
  background-color: rgba(255, 152, 0, 0.2);
  color: #ff9800;
}

.monaco-editor_status-message_HTKs_.monaco-editor_loading_lndwQ {
  background-color: rgba(33, 150, 243, 0.2);
  color: #2196f3;
}

.monaco-editor_status-message_HTKs_.monaco-editor_error_oftdq {
  background-color: rgba(244, 67, 54, 0.2);
  color: #f44336;
}

/* ========== 文件选择模态框 ========== */

.monaco-editor_modal-header_do7hX {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid var(--ui-tertiary);
}

.monaco-editor_modal-title_eKIof {
  font-size: 13px;
  color: var(--ui-text-primary-transparent);
}

.monaco-editor_select-all-btn_u2ISa {
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
  background: transparent;
  border: 1px solid var(--looks-secondary);
  color: var(--ui-text-primary-transparent);
  border-radius: 4px;
  font-family: inherit;
}

.monaco-editor_select-all-btn_u2ISa.monaco-editor_selected_uRRZq {
  background: var(--looks-secondary);
  color: #fff;
}

.monaco-editor_modal-body_bLl7J {
  padding: 12px;
  max-height: 280px;
  overflow-y: auto;
}

.monaco-editor_modal-file-item_KsRKL {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  margin-bottom: 6px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s;
  border: 1px solid var(--ui-tertiary);
  background-color: var(--ui-secondary);
}

.monaco-editor_modal-file-item_KsRKL.monaco-editor_selected_uRRZq {
  background-color: var(--badge-border);
}

.monaco-editor_modal-file-item_KsRKL:hover {
  background-color: var(--badge-border);
}

.monaco-editor_modal-checkbox__0t23 {
  margin-right: 10px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--looks-secondary);
}

.monaco-editor_modal-file-name_ZsocA {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
}

.monaco-editor_modal-function-count_o6F5P {
  font-size: 11px;
  color: var(--ui-text-primary-transparent);
  margin-left: 8px;
}

.monaco-editor_modal-empty-text_esBVt {
  color: var(--ui-text-primary-transparent);
  text-align: center;
  padding: 20px;
}

.monaco-editor_modal-buttons_oNHp7 {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px;
  border-top: 1px solid var(--ui-tertiary);
}

.monaco-editor_modal-cancel-btn_eDB98 {
  padding: 6px 14px;
  font-size: 13px;
  cursor: pointer;
  background: transparent;
  border: 1px solid var(--looks-secondary);
  color: var(--ui-text-primary-transparent);
  border-radius: 4px;
  font-family: inherit;
}

.monaco-editor_modal-confirm-btn_ZG239 {
  padding: 6px 14px;
  font-size: 13px;
  cursor: pointer;
  background: var(--looks-secondary);
  border: none;
  color: #fff;
  border-radius: 4px;
  font-weight: 500;
  font-family: inherit;
}

.monaco-editor_modal-confirm-btn_ZG239:hover {
  filter: brightness(1.1);
}

.monaco-editor_modal-confirm-btn_ZG239.monaco-editor_disabled_PDNYf {
  opacity: 0.5;
  cursor: not-allowed;
}

.monaco-editor_modal-box_MTdN_ {
  background-color: var(--ui-secondary);
}

.monaco-editor_rename-input_J1Kdx {
  flex: 1;
}

/* ========== 设置按钮 ========== */

.monaco-editor_settings-btn_BhTbi {
  background: none;
  border: 1px solid var(--ui-tertiary);
  border-radius: 3px;
  color: var(--text-primary);
  cursor: pointer;
  font-size: 14px;
  padding: 4px 8px;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
}

.monaco-editor_settings-btn_BhTbi:hover {
  background-color: var(--badge-border);
  border-color: var(--looks-secondary);
}

/* ========== 设置模态框 ========== */

.settings-modal {
  width: 360px !important;
  max-width: 360px !important;
}

.monaco-editor_settings-modal-content_KwMnI {
  padding: 16px;
}

.monaco-editor_settings-section_jv1_8 {
  margin-bottom: 16px;
}

.monaco-editor_settings-section-title_u9jFE {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: var(--looks-secondary);
  text-transform: uppercase;
  margin-bottom: 8px;
  display: block;
}

.monaco-editor_settings-row_iDFVf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid var(--ui-tertiary);
}

.monaco-editor_settings-row_iDFVf:last-child {
  border-bottom: none;
}

.monaco-editor_settings-label_V5TFf {
  font-size: 13px;
  color: var(--text-primary);
}

.monaco-editor_settings-number_tMSaO {
  width: 60px;
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid var(--ui-tertiary);
  border-radius: 3px;
  background-color: var(--ui-primary);
  color: var(--text-primary);
  text-align: center;
  outline: none;
  font-family: inherit;
}

.monaco-editor_settings-number_tMSaO:focus {
  border-color: var(--looks-secondary);
}

.monaco-editor_settings-select_jP8Q1 {
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid var(--ui-tertiary);
  border-radius: 3px;
  background-color: var(--ui-primary);
  color: var(--text-primary);
  outline: none;
  cursor: pointer;
  font-family: inherit;
  min-width: 100px;
}

.monaco-editor_settings-select_jP8Q1:focus {
  border-color: var(--looks-secondary);
}

.monaco-editor_settings-checkbox_DQF4K {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--looks-secondary);
}

.monaco-editor_settings-buttons_RIbA3 {
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;
  border-top: 1px solid var(--ui-tertiary);
}

.monaco-editor_settings-close-btn_b8PJc {
  padding: 6px 16px;
  font-size: 13px;
  cursor: pointer;
  background: var(--looks-secondary);
  border: none;
  color: #fff;
  border-radius: 4px;
  font-weight: 500;
  font-family: inherit;
}

.monaco-editor_settings-close-btn_b8PJc:hover {
  filter: brightness(1.1);
}

/* ========== Monaco 内部变量强制覆盖（防止外部红色污染） ========== */

.monaco-editor_editor-wrapper_VVwNC {
  /* 覆盖可能被外部插件污染的 --vscode-* 变量 */
  --vscode-scrollbar-shadow: transparent !important;
  --vscode-scrollbarSlider-background: var(--ui-tertiary);
  --vscode-scrollbarSlider-hoverBackground: var(--ui-transparent);
  --vscode-scrollbarSlider-activeBackground: var(--looks-secondary);
  --vscode-scrollbarSlider-border: transparent !important;

  --vscode-editor-lineHighlightBorder: transparent !important;
  --vscode-editor-background: var(--ui-primary);
  --vscode-editor-foreground: var(--text-primary);
  --vscode-editor-selectionBackground: var(--looks-transparent);
  --vscode-editor-inactiveSelectionBackground: var(--ui-tertiary);
  --vscode-editor-selectionHighlightBackground: var(--looks-light-transparent);
  --vscode-editorLineNumbers-foreground: var(--ui-tertiary);
  --vscode-editorCursor-foreground: var(--text-primary);

  --vscode-minimap-background: var(--ui-primary);
  --vscode-minimap-selectionHighlight: var(--looks-light-transparent);

  --vscode-input-background: var(--ui-primary);
  --vscode-input-border: var(--ui-tertiary);
  --vscode-input-foreground: var(--text-primary);

  --vscode-editorWidget-background: var(--ui-primary);
  --vscode-editorWidget-border: var(--ui-tertiary);

  --vscode-editorOverviewRuler-border: transparent;
}

/* 防止任何 outline/border 继承到红色 - 仅限编辑器内部 */

.monaco-editor_editor-wrapper_VVwNC .monaco-editor * {
  outline-color: inherit !important;
  border-color: inherit !important;
}

/* view-line 确保无边框 */

.monaco-editor_editor-wrapper_VVwNC .view-line {
  border-color: transparent !important;
  outline: none !important;
}

/* scroll decoration / scrollbar 边框 */

.monaco-editor_editor-wrapper_VVwNC .scroll-decoration,
.monaco-editor_editor-wrapper_VVwNC .monaco-scrollable-element > .scrollbar > .slider {
  border-color: transparent !important;
  box-shadow: none !important;
}

/* 滚动条轨道/底板 */

.monaco-editor_editor-wrapper_VVwNC .monaco-scrollable-element > .scrollbar {
  background-color: var(--ui-secondary) !important;
  border-color: transparent !important;
  box-shadow: none !important;
}

.monaco-editor_editor-wrapper_VVwNC .monaco-scrollable-element > .scrollbar.vertical,
.monaco-editor_editor-wrapper_VVwNC .monaco-scrollable-element > .scrollbar.horizontal {
  border: none !important;
}

.monaco-editor_editor-wrapper_VVwNC .monaco-scrollable-element > .scrollbar > .arrow {
  border-color: transparent !important;
  background-color: var(--ui-tertiary) !important;
}

/* 滚动条滑块 */

.monaco-editor_editor-wrapper_VVwNC .monaco-scrollable-element > .scrollbar > .slider {
  background-color: var(--ui-tertiary) !important;
}

.monaco-editor_editor-wrapper_VVwNC .monaco-scrollable-element > .scrollbar > .slider:hover {
  background-color: var(--text-primary) !important;
}

.monaco-editor_editor-wrapper_VVwNC .monaco-scrollable-element > .scrollbar > .slider.active {
  background-color: var(--looks-secondary) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/monaco-editor/monaco-editor.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C,+BAA+B;;AAE/B;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;EAC/B,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,oCAAoC;;AAEpC;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA,gCAAgC;;AAEhC;EACE,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iCAAiC;;AAEjC;EACE,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;EAC1B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,yCAAyC;EACzC,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qCAAqC;EACrC,yCAAyC;EACzC,eAAe;EACf,kCAAkC;EAClC,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA,kCAAkC;;AAElC;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,eAAe;EACf,kBAAkB;AACpB;;AAEA,iCAAiC;;AAEjC;EACE,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gCAAgC;;AAEhC;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,+BAA+B;;AAE/B;EACE,iBAAiB;EACjB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,wCAAwC;EACxC,yCAAyC;EACzC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,wCAAwC;EACxC,yCAAyC;EACzC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,OAAO;AACT;;AAEA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA,gCAAgC;;AAEhC;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,oDAAoD;;AAEpD;EACE,+BAA+B;EAC/B,iDAAiD;EACjD,uDAAuD;EACvD,+DAA+D;EAC/D,iEAAiE;EACjE,uDAAuD;;EAEvD,2DAA2D;EAC3D,6CAA6C;EAC7C,+CAA+C;EAC/C,6DAA6D;EAC7D,+DAA+D;EAC/D,4EAA4E;EAC5E,yDAAyD;EACzD,qDAAqD;;EAErD,8CAA8C;EAC9C,mEAAmE;;EAEnE,4CAA4C;EAC5C,yCAAyC;EACzC,8CAA8C;;EAE9C,mDAAmD;EACnD,gDAAgD;;EAEhD,gDAAgD;AAClD;;AAEA,wCAAwC;;AAExC;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA,oBAAoB;;AAEpB;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA,qCAAqC;;AAErC;;EAEE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,aAAa;;AAEb;EACE,gDAAgD;EAChD,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA,UAAU;;AAEV;EACE,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mDAAmD;AACrD","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* ========== 原有样式 ========== */\n\n.container {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\n.toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  background: var(--ui-secondary);\n  border-bottom: 1px solid var(--ui-tertiary);\n  min-height: 40px;\n  height: 40px;\n  box-sizing: border-box;\n}\n\n.languageSelector {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.toolbarLabel {\n  font-size: 0.875rem;\n  color: var(--ui-modal-foreground);\n  font-weight: 500;\n}\n\n.languageButton {\n  font-family: inherit;\n  font-size: 0.875rem;\n  padding: 0.375rem 0.75rem;\n  margin: 0;\n  border: 1px solid var(--ui-tertiary);\n  border-radius: 4px;\n  cursor: pointer;\n  background: var(--ui-tertiary);\n  color: var(--ui-modal-foreground);\n  transition: all 0.2s ease;\n}\n\n.languageButton:hover {\n  background: var(--badge-border);\n  border-color: var(--looks-secondary);\n}\n\n.activeLanguage {\n  background: var(--looks-secondary);\n  color: white;\n  border-color: var(--looks-secondary);\n}\n\n.activeLanguage:hover {\n  background: var(--looks-secondary);\n  filter: brightness(1.1);\n}\n\n.toolbarActions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.toolbarButton {\n  font-family: inherit;\n  font-size: 0.875rem;\n  padding: 0.375rem 0.75rem;\n  margin: 0;\n  border: 1px solid var(--ui-tertiary);\n  border-radius: 4px;\n  cursor: pointer;\n  background: var(--ui-tertiary);\n  color: var(--ui-modal-foreground);\n  transition: all 0.2s ease;\n}\n\n.toolbarButton:hover {\n  background: var(--badge-border);\n  border-color: var(--looks-secondary);\n}\n\n.editorContainer {\n  position: absolute;\n  top: 40px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  color: var(--ui-modal-foreground);\n  font-size: 1rem;\n}\n\n.error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  color: var(--error-primary);\n  font-size: 1rem;\n  padding: 1rem;\n  text-align: center;\n}\n\n:global(.file-selection-modal) {\n  width: 320px !important;\n  max-width: 320px !important;\n}\n\n/* ========== 编辑器主体布局样式 ========== */\n\n.editor-wrapper {\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n\n/* ========== 侧边栏样式 ========== */\n\n.sidebar {\n  width: 200px;\n  background-color: var(--ui-secondary);\n  border-right: 1px solid var(--ui-tertiary);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.sidebar-header {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--ui-tertiary);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--ui-tertiary);\n}\n\n.sidebar-title {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  color: var(--text-primary);\n}\n\n.file-list {\n  flex: 1;\n  overflow: auto;\n  padding: 8px 0;\n}\n\n.file-item {\n  display: flex;\n  align-items: center;\n  padding: 6px 12px;\n  cursor: pointer;\n  background-color: transparent;\n  border-left: 2px solid transparent;\n  transition: background-color 0.15s;\n}\n\n.file-item:hover {\n  background-color: var(--badge-border);\n}\n\n.file-item.active {\n  background-color: var(--badge-border);\n  border-left-color: var(--looks-secondary);\n}\n\n.file-icon {\n  width: 16px;\n  height: 16px;\n  border-radius: 3px;\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: bold;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.file-icon.light-text {\n  color: #000;\n}\n\n.file-name {\n  flex: 1;\n  font-size: 13px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--text-primary);\n}\n\n.file-actions {\n  display: flex;\n  gap: 4px;\n  opacity: 0;\n  transition: opacity 0.15s;\n}\n\n.file-item:hover .file-actions {\n  opacity: 1;\n}\n\n.file-action-btn {\n  padding: 2px 4px;\n  font-size: 12px;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  color: var(--ui-text-primary-transparent);\n}\n\n.file-action-btn:hover {\n  color: var(--text-primary);\n}\n\n/* ========== 新建文件区域 ========== */\n\n.new-file-section {\n  padding: 8px 12px;\n  border-top: 1px solid var(--looks-secondary);\n}\n\n.new-file-input {\n  width: 100%;\n  padding: 6px 8px;\n  font-size: 13px;\n  border: 1px solid var(--looks-secondary);\n  border-radius: 3px;\n  background-color: var(--ui-primary);\n  color: var(--text-primary);\n  outline: none;\n  font-family: inherit;\n}\n\n.new-file-input::-ms-input-placeholder {\n  color: var(--ui-text-primary-transparent);\n}\n\n.new-file-input::placeholder {\n  color: var(--ui-text-primary-transparent);\n}\n\n.new-file-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.new-file-btn-create {\n  padding: 4px 12px;\n  font-size: 12px;\n  background-color: var(--looks-secondary);\n  color: #fff;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.new-file-btn-create:hover {\n  filter: brightness(1.1);\n}\n\n.new-file-btn-cancel {\n  padding: 4px 12px;\n  font-size: 12px;\n  background-color: transparent;\n  color: var(--ui-text-primary-transparent);\n  border: 1px solid var(--ui-tertiary);\n  border-radius: 3px;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.new-file-btn-cancel:hover {\n  border-color: var(--ui-text-primary-transparent);\n}\n\n.new-file-trigger {\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  background-color: var(--ui-secondary);\n  color: var(--ui-text-primary-transparent);\n  font-size: 13px;\n  transition: background-color 0.15s;\n  font-family: inherit;\n  border: none;\n  width: 100%;\n  text-align: left;\n}\n\n.new-file-trigger:hover {\n  background-color: var(--looks-secondary);\n}\n\n.new-file-icon {\n  font-size: 16px;\n}\n\n/* ========== 编辑器区域样式 ========== */\n\n.editor-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.editor-header {\n  padding: 8px 16px;\n  border-bottom: 1px solid var(--ui-tertiary);\n  background-color: var(--ui-tertiary);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.editor-header-left,\n.editor-header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.editor-filename {\n  font-size: 13px;\n  color: var(--text-primary);\n}\n\n/* ========== 缩放控制 ========== */\n\n.zoom-control {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 6px;\n  background-color: var(--ui-tertiary);\n  border-radius: 4px;\n}\n\n.zoom-btn {\n  background: none;\n  border: none;\n  color: var(--text-primary);\n  cursor: pointer;\n  font-size: 14px;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-family: inherit;\n}\n\n.zoom-btn:hover {\n  background-color: var(--badge-border);\n}\n\n.zoom-value {\n  font-size: 11px;\n  color: var(--ui-text-primary-transparent);\n  min-width: 30px;\n  text-align: center;\n}\n\n/* ========== 生成积木按钮 ========== */\n\n.generate-btn {\n  padding: 6px 12px;\n  font-size: 12px;\n  background-color: var(--looks-secondary);\n  color: #fff;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-family: inherit;\n}\n\n.generate-btn:hover {\n  filter: brightness(1.1);\n}\n\n/* ========== 编辑器容器 ========== */\n\n.editor-content {\n  flex: 1;\n  overflow: hidden;\n}\n\n/* ========== 空状态 ========== */\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--ui-text-primary-transparent);\n  font-size: 14px;\n}\n\n.empty-state-hint {\n  font-size: 12px;\n  margin-top: 8px;\n}\n\n/* ========== 状态消息 ========== */\n\n.status-message {\n  padding: 8px 16px;\n  font-size: 12px;\n  border-bottom: 1px solid var(--ui-tertiary);\n}\n\n.status-message.success {\n  background-color: rgba(76, 175, 80, 0.2);\n  color: #4caf50;\n}\n\n.status-message.warning {\n  background-color: rgba(255, 152, 0, 0.2);\n  color: #ff9800;\n}\n\n.status-message.loading {\n  background-color: rgba(33, 150, 243, 0.2);\n  color: #2196f3;\n}\n\n.status-message.error {\n  background-color: rgba(244, 67, 54, 0.2);\n  color: #f44336;\n}\n\n/* ========== 文件选择模态框 ========== */\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  border-bottom: 1px solid var(--ui-tertiary);\n}\n\n.modal-title {\n  font-size: 13px;\n  color: var(--ui-text-primary-transparent);\n}\n\n.select-all-btn {\n  padding: 4px 12px;\n  font-size: 12px;\n  cursor: pointer;\n  background: transparent;\n  border: 1px solid var(--looks-secondary);\n  color: var(--ui-text-primary-transparent);\n  border-radius: 4px;\n  font-family: inherit;\n}\n\n.select-all-btn.selected {\n  background: var(--looks-secondary);\n  color: #fff;\n}\n\n.modal-body {\n  padding: 12px;\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.modal-file-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 10px;\n  margin-bottom: 6px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.15s;\n  border: 1px solid var(--ui-tertiary);\n  background-color: var(--ui-secondary);\n}\n\n.modal-file-item.selected {\n  background-color: var(--badge-border);\n}\n\n.modal-file-item:hover {\n  background-color: var(--badge-border);\n}\n\n.modal-checkbox {\n  margin-right: 10px;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: var(--looks-secondary);\n}\n\n.modal-file-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.modal-function-count {\n  font-size: 11px;\n  color: var(--ui-text-primary-transparent);\n  margin-left: 8px;\n}\n\n.modal-empty-text {\n  color: var(--ui-text-primary-transparent);\n  text-align: center;\n  padding: 20px;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 12px;\n  border-top: 1px solid var(--ui-tertiary);\n}\n\n.modal-cancel-btn {\n  padding: 6px 14px;\n  font-size: 13px;\n  cursor: pointer;\n  background: transparent;\n  border: 1px solid var(--looks-secondary);\n  color: var(--ui-text-primary-transparent);\n  border-radius: 4px;\n  font-family: inherit;\n}\n\n.modal-confirm-btn {\n  padding: 6px 14px;\n  font-size: 13px;\n  cursor: pointer;\n  background: var(--looks-secondary);\n  border: none;\n  color: #fff;\n  border-radius: 4px;\n  font-weight: 500;\n  font-family: inherit;\n}\n\n.modal-confirm-btn:hover {\n  filter: brightness(1.1);\n}\n\n.modal-confirm-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.modal-box {\n  background-color: var(--ui-secondary);\n}\n\n.rename-input {\n  flex: 1;\n}\n\n/* ========== 设置按钮 ========== */\n\n.settings-btn {\n  background: none;\n  border: 1px solid var(--ui-tertiary);\n  border-radius: 3px;\n  color: var(--text-primary);\n  cursor: pointer;\n  font-size: 14px;\n  padding: 4px 8px;\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.settings-btn:hover {\n  background-color: var(--badge-border);\n  border-color: var(--looks-secondary);\n}\n\n/* ========== 设置模态框 ========== */\n\n:global(.settings-modal) {\n  width: 360px !important;\n  max-width: 360px !important;\n}\n\n.settings-modal-content {\n  padding: 16px;\n}\n\n.settings-section {\n  margin-bottom: 16px;\n}\n\n.settings-section-title {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  color: var(--looks-secondary);\n  text-transform: uppercase;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.settings-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--ui-tertiary);\n}\n\n.settings-row:last-child {\n  border-bottom: none;\n}\n\n.settings-label {\n  font-size: 13px;\n  color: var(--text-primary);\n}\n\n.settings-number {\n  width: 60px;\n  padding: 4px 8px;\n  font-size: 13px;\n  border: 1px solid var(--ui-tertiary);\n  border-radius: 3px;\n  background-color: var(--ui-primary);\n  color: var(--text-primary);\n  text-align: center;\n  outline: none;\n  font-family: inherit;\n}\n\n.settings-number:focus {\n  border-color: var(--looks-secondary);\n}\n\n.settings-select {\n  padding: 4px 8px;\n  font-size: 13px;\n  border: 1px solid var(--ui-tertiary);\n  border-radius: 3px;\n  background-color: var(--ui-primary);\n  color: var(--text-primary);\n  outline: none;\n  cursor: pointer;\n  font-family: inherit;\n  min-width: 100px;\n}\n\n.settings-select:focus {\n  border-color: var(--looks-secondary);\n}\n\n.settings-checkbox {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: var(--looks-secondary);\n}\n\n.settings-buttons {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 12px;\n  border-top: 1px solid var(--ui-tertiary);\n}\n\n.settings-close-btn {\n  padding: 6px 16px;\n  font-size: 13px;\n  cursor: pointer;\n  background: var(--looks-secondary);\n  border: none;\n  color: #fff;\n  border-radius: 4px;\n  font-weight: 500;\n  font-family: inherit;\n}\n\n.settings-close-btn:hover {\n  filter: brightness(1.1);\n}\n\n/* ========== Monaco 内部变量强制覆盖（防止外部红色污染） ========== */\n\n.editor-wrapper {\n  /* 覆盖可能被外部插件污染的 --vscode-* 变量 */\n  --vscode-scrollbar-shadow: transparent !important;\n  --vscode-scrollbarSlider-background: var(--ui-tertiary);\n  --vscode-scrollbarSlider-hoverBackground: var(--ui-transparent);\n  --vscode-scrollbarSlider-activeBackground: var(--looks-secondary);\n  --vscode-scrollbarSlider-border: transparent !important;\n\n  --vscode-editor-lineHighlightBorder: transparent !important;\n  --vscode-editor-background: var(--ui-primary);\n  --vscode-editor-foreground: var(--text-primary);\n  --vscode-editor-selectionBackground: var(--looks-transparent);\n  --vscode-editor-inactiveSelectionBackground: var(--ui-tertiary);\n  --vscode-editor-selectionHighlightBackground: var(--looks-light-transparent);\n  --vscode-editorLineNumbers-foreground: var(--ui-tertiary);\n  --vscode-editorCursor-foreground: var(--text-primary);\n\n  --vscode-minimap-background: var(--ui-primary);\n  --vscode-minimap-selectionHighlight: var(--looks-light-transparent);\n\n  --vscode-input-background: var(--ui-primary);\n  --vscode-input-border: var(--ui-tertiary);\n  --vscode-input-foreground: var(--text-primary);\n\n  --vscode-editorWidget-background: var(--ui-primary);\n  --vscode-editorWidget-border: var(--ui-tertiary);\n\n  --vscode-editorOverviewRuler-border: transparent;\n}\n\n/* 防止任何 outline/border 继承到红色 - 仅限编辑器内部 */\n\n.editor-wrapper :global(.monaco-editor) * {\n  outline-color: inherit !important;\n  border-color: inherit !important;\n}\n\n/* view-line 确保无边框 */\n\n.editor-wrapper :global(.view-line) {\n  border-color: transparent !important;\n  outline: none !important;\n}\n\n/* scroll decoration / scrollbar 边框 */\n\n.editor-wrapper :global(.scroll-decoration),\n.editor-wrapper :global(.monaco-scrollable-element) > :global(.scrollbar) > :global(.slider) {\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n\n/* 滚动条轨道/底板 */\n\n.editor-wrapper :global(.monaco-scrollable-element) > :global(.scrollbar) {\n  background-color: var(--ui-secondary) !important;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n\n.editor-wrapper :global(.monaco-scrollable-element) > :global(.scrollbar.vertical),\n.editor-wrapper :global(.monaco-scrollable-element) > :global(.scrollbar.horizontal) {\n  border: none !important;\n}\n\n.editor-wrapper :global(.monaco-scrollable-element) > :global(.scrollbar) > :global(.arrow) {\n  border-color: transparent !important;\n  background-color: var(--ui-tertiary) !important;\n}\n\n/* 滚动条滑块 */\n\n.editor-wrapper :global(.monaco-scrollable-element) > :global(.scrollbar) > :global(.slider) {\n  background-color: var(--ui-tertiary) !important;\n}\n\n.editor-wrapper :global(.monaco-scrollable-element) > :global(.scrollbar) > :global(.slider):hover {\n  background-color: var(--text-primary) !important;\n}\n\n.editor-wrapper :global(.monaco-scrollable-element) > :global(.scrollbar) > :global(.slider.active) {\n  background-color: var(--looks-secondary) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `monaco-editor_container_MRSSZ`,
	"toolbar": `monaco-editor_toolbar_wEfZ2`,
	"languageSelector": `monaco-editor_languageSelector_qodI4`,
	"toolbarLabel": `monaco-editor_toolbarLabel_ZmYqI`,
	"languageButton": `monaco-editor_languageButton_a_eiu`,
	"activeLanguage": `monaco-editor_activeLanguage_ABYw_`,
	"toolbarActions": `monaco-editor_toolbarActions_OchyJ`,
	"toolbarButton": `monaco-editor_toolbarButton_LCd1A`,
	"editorContainer": `monaco-editor_editorContainer_eeHrh`,
	"loading": `monaco-editor_loading_lndwQ`,
	"error": `monaco-editor_error_oftdq`,
	"editor-wrapper": `monaco-editor_editor-wrapper_VVwNC`,
	"editorWrapper": `monaco-editor_editor-wrapper_VVwNC`,
	"sidebar": `monaco-editor_sidebar_ybah9`,
	"sidebar-header": `monaco-editor_sidebar-header_sPNpp`,
	"sidebarHeader": `monaco-editor_sidebar-header_sPNpp`,
	"sidebar-title": `monaco-editor_sidebar-title_xqHHU`,
	"sidebarTitle": `monaco-editor_sidebar-title_xqHHU`,
	"file-list": `monaco-editor_file-list_VzHlx`,
	"fileList": `monaco-editor_file-list_VzHlx`,
	"file-item": `monaco-editor_file-item_IksU6`,
	"fileItem": `monaco-editor_file-item_IksU6`,
	"active": `monaco-editor_active_ESw8f`,
	"file-icon": `monaco-editor_file-icon_s6fkY`,
	"fileIcon": `monaco-editor_file-icon_s6fkY`,
	"light-text": `monaco-editor_light-text_M3Q3m`,
	"lightText": `monaco-editor_light-text_M3Q3m`,
	"file-name": `monaco-editor_file-name_q8jeY`,
	"fileName": `monaco-editor_file-name_q8jeY`,
	"file-actions": `monaco-editor_file-actions_Qo7OT`,
	"fileActions": `monaco-editor_file-actions_Qo7OT`,
	"file-action-btn": `monaco-editor_file-action-btn_yGGsV`,
	"fileActionBtn": `monaco-editor_file-action-btn_yGGsV`,
	"new-file-section": `monaco-editor_new-file-section_GLm50`,
	"newFileSection": `monaco-editor_new-file-section_GLm50`,
	"new-file-input": `monaco-editor_new-file-input_wcSpx`,
	"newFileInput": `monaco-editor_new-file-input_wcSpx`,
	"new-file-actions": `monaco-editor_new-file-actions_tHDFJ`,
	"newFileActions": `monaco-editor_new-file-actions_tHDFJ`,
	"new-file-btn-create": `monaco-editor_new-file-btn-create_lybLp`,
	"newFileBtnCreate": `monaco-editor_new-file-btn-create_lybLp`,
	"new-file-btn-cancel": `monaco-editor_new-file-btn-cancel_yS4Cd`,
	"newFileBtnCancel": `monaco-editor_new-file-btn-cancel_yS4Cd`,
	"new-file-trigger": `monaco-editor_new-file-trigger_KajD8`,
	"newFileTrigger": `monaco-editor_new-file-trigger_KajD8`,
	"new-file-icon": `monaco-editor_new-file-icon_qI7JL`,
	"newFileIcon": `monaco-editor_new-file-icon_qI7JL`,
	"editor-area": `monaco-editor_editor-area_AbVwU`,
	"editorArea": `monaco-editor_editor-area_AbVwU`,
	"editor-header": `monaco-editor_editor-header_nw6W8`,
	"editorHeader": `monaco-editor_editor-header_nw6W8`,
	"editor-header-left": `monaco-editor_editor-header-left_vkLDc`,
	"editorHeaderLeft": `monaco-editor_editor-header-left_vkLDc`,
	"editor-header-right": `monaco-editor_editor-header-right_PDzx3`,
	"editorHeaderRight": `monaco-editor_editor-header-right_PDzx3`,
	"editor-filename": `monaco-editor_editor-filename_V6Eu5`,
	"editorFilename": `monaco-editor_editor-filename_V6Eu5`,
	"zoom-control": `monaco-editor_zoom-control_Np_vk`,
	"zoomControl": `monaco-editor_zoom-control_Np_vk`,
	"zoom-btn": `monaco-editor_zoom-btn_RLZvn`,
	"zoomBtn": `monaco-editor_zoom-btn_RLZvn`,
	"zoom-value": `monaco-editor_zoom-value_LFgyB`,
	"zoomValue": `monaco-editor_zoom-value_LFgyB`,
	"generate-btn": `monaco-editor_generate-btn_Hxu8n`,
	"generateBtn": `monaco-editor_generate-btn_Hxu8n`,
	"editor-content": `monaco-editor_editor-content_h9MU1`,
	"editorContent": `monaco-editor_editor-content_h9MU1`,
	"empty-state": `monaco-editor_empty-state_P8ThV`,
	"emptyState": `monaco-editor_empty-state_P8ThV`,
	"empty-state-hint": `monaco-editor_empty-state-hint_fLrb9`,
	"emptyStateHint": `monaco-editor_empty-state-hint_fLrb9`,
	"status-message": `monaco-editor_status-message_HTKs_`,
	"statusMessage": `monaco-editor_status-message_HTKs_`,
	"success": `monaco-editor_success_E5Uj1`,
	"warning": `monaco-editor_warning_bNkwk`,
	"modal-header": `monaco-editor_modal-header_do7hX`,
	"modalHeader": `monaco-editor_modal-header_do7hX`,
	"modal-title": `monaco-editor_modal-title_eKIof`,
	"modalTitle": `monaco-editor_modal-title_eKIof`,
	"select-all-btn": `monaco-editor_select-all-btn_u2ISa`,
	"selectAllBtn": `monaco-editor_select-all-btn_u2ISa`,
	"selected": `monaco-editor_selected_uRRZq`,
	"modal-body": `monaco-editor_modal-body_bLl7J`,
	"modalBody": `monaco-editor_modal-body_bLl7J`,
	"modal-file-item": `monaco-editor_modal-file-item_KsRKL`,
	"modalFileItem": `monaco-editor_modal-file-item_KsRKL`,
	"modal-checkbox": `monaco-editor_modal-checkbox__0t23`,
	"modalCheckbox": `monaco-editor_modal-checkbox__0t23`,
	"modal-file-name": `monaco-editor_modal-file-name_ZsocA`,
	"modalFileName": `monaco-editor_modal-file-name_ZsocA`,
	"modal-function-count": `monaco-editor_modal-function-count_o6F5P`,
	"modalFunctionCount": `monaco-editor_modal-function-count_o6F5P`,
	"modal-empty-text": `monaco-editor_modal-empty-text_esBVt`,
	"modalEmptyText": `monaco-editor_modal-empty-text_esBVt`,
	"modal-buttons": `monaco-editor_modal-buttons_oNHp7`,
	"modalButtons": `monaco-editor_modal-buttons_oNHp7`,
	"modal-cancel-btn": `monaco-editor_modal-cancel-btn_eDB98`,
	"modalCancelBtn": `monaco-editor_modal-cancel-btn_eDB98`,
	"modal-confirm-btn": `monaco-editor_modal-confirm-btn_ZG239`,
	"modalConfirmBtn": `monaco-editor_modal-confirm-btn_ZG239`,
	"disabled": `monaco-editor_disabled_PDNYf`,
	"modal-box": `monaco-editor_modal-box_MTdN_`,
	"modalBox": `monaco-editor_modal-box_MTdN_`,
	"rename-input": `monaco-editor_rename-input_J1Kdx`,
	"renameInput": `monaco-editor_rename-input_J1Kdx`,
	"settings-btn": `monaco-editor_settings-btn_BhTbi`,
	"settingsBtn": `monaco-editor_settings-btn_BhTbi`,
	"settings-modal-content": `monaco-editor_settings-modal-content_KwMnI`,
	"settingsModalContent": `monaco-editor_settings-modal-content_KwMnI`,
	"settings-section": `monaco-editor_settings-section_jv1_8`,
	"settingsSection": `monaco-editor_settings-section_jv1_8`,
	"settings-section-title": `monaco-editor_settings-section-title_u9jFE`,
	"settingsSectionTitle": `monaco-editor_settings-section-title_u9jFE`,
	"settings-row": `monaco-editor_settings-row_iDFVf`,
	"settingsRow": `monaco-editor_settings-row_iDFVf`,
	"settings-label": `monaco-editor_settings-label_V5TFf`,
	"settingsLabel": `monaco-editor_settings-label_V5TFf`,
	"settings-number": `monaco-editor_settings-number_tMSaO`,
	"settingsNumber": `monaco-editor_settings-number_tMSaO`,
	"settings-select": `monaco-editor_settings-select_jP8Q1`,
	"settingsSelect": `monaco-editor_settings-select_jP8Q1`,
	"settings-checkbox": `monaco-editor_settings-checkbox_DQF4K`,
	"settingsCheckbox": `monaco-editor_settings-checkbox_DQF4K`,
	"settings-buttons": `monaco-editor_settings-buttons_RIbA3`,
	"settingsButtons": `monaco-editor_settings-buttons_RIbA3`,
	"settings-close-btn": `monaco-editor_settings-close-btn_b8PJc`,
	"settingsCloseBtn": `monaco-editor_settings-close-btn_b8PJc`
};
export default ___CSS_LOADER_EXPORT___;
